export function isDate(obj: unknown): obj is Date {
  return (obj as Date).constructor.name === "Date";
}
